import { useEffect, useState } from 'react';
import { sdkBridge } from '../sdk-bridge';

/**
 * Hook for fetching user authentication token from the SDK
 * Returns null for anonymous users
 */
export const useUserToken = () => {
  const [userToken, setUserToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await sdkBridge.requestUserToken();
        setUserToken(token);
      } catch (error) {
        console.warn('Failed to get user token:', error);
        setUserToken(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchToken();
  }, []);

  return { userToken, isLoading };
};
